import qs from 'qs';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { Meta } from '../communication/types/Meta';
import { INotification } from './types/INotification';

export interface IListNotifications {
  nodes: INotification[];
  meta: Meta;
  unread_count: number;
}

export interface IListNotificationsParams {
  limit?: number;
  cursor?: string;
  cursor_direction?: 'next' | 'previous';
}

export const listNotifications = async (
  params?: IListNotificationsParams,
  userRole?: string,
): Promise<IListNotifications> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get<IListNotifications>(
    `${prefix}/notifications${params ? `?${qs.stringify(params, { skipNulls: true })}` : ''}`,
  );

  return data;
};
